(function() {
'use strict';

angular
    .module('transfers')
    .service('transferDetail', transferDetail);

function transferDetail($http, $cacheFactory, $q, broker) {
    const url = '/api3/transfers/details/';
    let timeout;
    const promiseCache = $cacheFactory.get('detailPromiseCache') || $cacheFactory('detailPromiseCache');

    const service = {
        getTransferDetails,
        rehydrate
    };

    function getTransferDetails(request) {
        if (timeout != null) {
            timeout.resolve('CANCELLED');
        }
        timeout = $q.defer();
        return $http.post(`${url}get`, request, {
            timeout: timeout.promise,
            customErrCallback(args) {
                if (args.status && args.status !== -1) {
                    broker.publish('transferRequestFailed');
                }
                return true;
            }

        }).then(function(res) {
            promiseCache.remove(res.data.DetailsSessionId);
            timeout = null;
            return res.data;
        });
    }

    function rehydrate(id) {
        if (!promiseCache.get(id)) {
            promiseCache.put(id, $http.post(`${url}getfromsession`, { DetailsSessionId: id }, { ignoreErrors: true }).then(function(res) {
                return res.data;
            }));
        }
        return promiseCache.get(id);
    }

    return service;
}
})();
